import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";

import "@/styles/index.css";
import { App, RootErrorBoundary } from "@/app";
import { followSystemTheme } from "@/components/app/theme";
import { TooltipProvider } from "@/components/ui/misc";
import { AuthProvider } from "@/lib/auth";
import { queryClient } from "@/lib/query";
import { BRAND_NAME } from "@/config/brand";

// index.html carries the landing page's title for crawlers; every other screen uses the brand name
if (window.location.pathname !== "/") document.title = BRAND_NAME;
followSystemTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RootErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <TooltipProvider>
            <App />
            <Toaster
              theme="system"
              position="bottom-right"
              toastOptions={{ className: "!text-sm !rounded-md !border !shadow-pop" }}
            />
          </TooltipProvider>
        </AuthProvider>
      </QueryClientProvider>
    </RootErrorBoundary>
  </StrictMode>,
);
